import { TFunction } from 'i18next';
import { ModalMode } from './types';

export const getModalTitle = (mode: ModalMode, t: TFunction) => {
  const titles: Record<ModalMode, string> = {
    view: t('contacts.viewContact', 'View Contact'),
    edit: t('contacts.editContact', 'Edit Contact'),
    create: t('contacts.createContact', 'Create Contact')
  };
  return titles[mode];
};
